module.exports = __webpack_public_path__ + "static/apartment-713e77b6c1ebf15b80335139d6d6cb50.webp";